"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (name, version) {
    window.appInfo = window.appInfo || {};
    try {
        window.appInfo[name] = version;
    } catch (e) {
        console.warn("unable to set app info for " + name + "@" + version + ":", e);
    }
};


//////////////////
// WEBPACK FOOTER
// ./~/@zillow/client-profiler-core/dist/utils/setAppInfo.js
// module id = 516
// module chunks = 5